// ======================================================================
// File Name       : CourseUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import { MIN_DATE, MAX_DATE, MIN_MAX_DATE_TXT } from '../utils/index';
import { DEFAULT_DATE_FORMAT, STRUCTURE_TYPE } from '../constants/index';
import { COURSE_GROUP_RELATION_TYPE, END_CONDITION_TYPE_FOR_COURSE, END_CONDITION_TYPE_FOR_COURSE_LIST } from '../constants/CourseConstants';
import { START_CONDITION_TYPE_FOR_BOX, START_CONDITION_TYPE_FOR_ITEM } from '../constants/ItemConstant';

export const findTree = (structure, structureList) =>
  structureList.reduce((children, curStructure) => {
    const { structureSecernId, parentCourseBoxSecernId } = curStructure;
    // Find child box/item of course
    if (parentCourseBoxSecernId && parentCourseBoxSecernId === structure.structureSecernId) {
      curStructure.children = findTree({ structureSecernId }, structureList);
      children.push(curStructure);
    }

    return children;
  }, []);

export const findChildren = (structure, structureList) =>
  structureList.reduce((children, curStructure) => {
    const { structureSecernId, parentCourseBoxSecernId } = curStructure;
    if (parentCourseBoxSecernId && parentCourseBoxSecernId === structure.structureSecernId) {
      children.push(curStructure);
    }
  }, []);

export function getDisplayPublicPeriod(publicPeriodFrom, publicPeriodTo) {
  const { noLimitFrom, noLimitTo } = getLimitationInfoPublicPeriod(
    publicPeriodFrom,
    publicPeriodTo,
  );
  const mPublicPeriodFrom = moment(publicPeriodFrom);
  const mPublicPeriodTo = moment(publicPeriodTo);
  if (noLimitFrom && noLimitTo) {
    return '無期限';
  } else if (noLimitFrom) {
    return `～ ${mPublicPeriodTo.format(DEFAULT_DATE_FORMAT)}`;
  } else if (noLimitTo) {
    return `${mPublicPeriodFrom.format(DEFAULT_DATE_FORMAT)}～無期限`;
  }
  return `${mPublicPeriodFrom.format(DEFAULT_DATE_FORMAT)}～${mPublicPeriodTo.format(DEFAULT_DATE_FORMAT)}`;
}

export function getLimitationInfoPublicPeriod(publicPeriodFrom, publicPeriodTo) {
  let noLimitFrom = true;
  let noLimitTo = true;
  let mPublicPeriodFrom = null;
  let mPublicPeriodTo = null;
  if (publicPeriodFrom && publicPeriodFrom !== MIN_MAX_DATE_TXT) {
    mPublicPeriodFrom = moment(publicPeriodFrom);
    noLimitFrom = mPublicPeriodFrom.isSameOrBefore(MIN_DATE);
  }
  if (publicPeriodTo && publicPeriodTo !== MIN_MAX_DATE_TXT) {
    mPublicPeriodTo = moment(publicPeriodTo);
    noLimitTo = mPublicPeriodTo.isSameOrAfter(MAX_DATE);
  }
  return {
    noLimitFrom,
    noLimitTo,
  };
}

/**
 * Function get Exist Items Of box or course
 * @param {*} childSercernIdList
 * @param {*} bySecernId
 */
export function getExistItemsOfData(childSercernIdList, bySecernId) {
  const itemsOfBox = [];
  childSercernIdList && childSercernIdList.length &&
  childSercernIdList.forEach((childSercernId) => {
    if (bySecernId && bySecernId[childSercernId] &&
    childSercernId === bySecernId[childSercernId].structureSecernId &&
    bySecernId[childSercernId].structureType === STRUCTURE_TYPE.ITEM) {
      itemsOfBox.push(childSercernId);
    }
  }, this);
  return itemsOfBox;
}

// sprint_20230522_tma START
export function getDisplayStartConditionTypeForItem(startConditionTypeForItem, progressRatioForItemStart) {
  switch (startConditionTypeForItem) {
    case START_CONDITION_TYPE_FOR_ITEM.NO_CONDITION:
      return 'なし';
    case START_CONDITION_TYPE_FOR_ITEM.AND_CONDITION:
      return '指定されたコンテンツを全て完了';
    case START_CONDITION_TYPE_FOR_ITEM.OR_CONDITION:
      return '指定されたコンテンツのいずれかを完了';
    case START_CONDITION_TYPE_FOR_ITEM.ACHIEVEMENT_RATE_CONDITION:
      return `指定されたコンテンツの完了条件達成率：${progressRatioForItemStart}%`;
    default:
      return '';
  }
}

export function getDisplayStartConditionTypeForBox(startConditionTypeForBox, progressRatioForBoxStart) {
  switch (startConditionTypeForBox) {
    case START_CONDITION_TYPE_FOR_BOX.NO_CONDITION:
      return 'なし';
    case START_CONDITION_TYPE_FOR_BOX.AND_CONDITION:
      return '指定されたコンテンツを全て完了';
    case START_CONDITION_TYPE_FOR_BOX.OR_CONDITION:
      return '指定されたコンテンツのいずれかを完了';
    case START_CONDITION_TYPE_FOR_BOX.ACHIEVEMENT_RATE_CONDITION:
      return `指定されたコンテンツの完了条件達成率：${progressRatioForBoxStart}%`;
    default:
      return '';
  }
}
// sprint_20230522_tma END

// Step 10.2.0 START
export function getDisplayEndConditionTypeForCourse(endConditionTypeForCourse, progressRatioForCourseEnd) {
  switch (endConditionTypeForCourse) {
    case END_CONDITION_TYPE_FOR_COURSE.NONE:
      return 'なし';
    case END_CONDITION_TYPE_FOR_COURSE.AND:
      return '指定されたコンテンツを全て完了';
    case END_CONDITION_TYPE_FOR_COURSE.OR:
      return '指定されたコンテンツのいずれかを完了';
    case END_CONDITION_TYPE_FOR_COURSE.PROGRESS:
      return `指定されたコンテンツの完了条件達成率：${progressRatioForCourseEnd}%`;
    default:
      return '';
  }
}

export function isEnableCourseEndCondition(endConditionTypeForCourse) {
  return END_CONDITION_TYPE_FOR_COURSE_LIST.indexOf(endConditionTypeForCourse) > -1;
}
// Step 10.2.0 END
